import { authService } from '../services/auth.ts';
import { onboardingService } from '../services/onboarding.ts';

import './app-shell.ts';
import '../pages/app/login/login.ts';
import '../pages/app/onboarding/onboarding.ts';

export class AppRoot extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkRegistrationToken();
    this.render();
    window.addEventListener('auth-state-changed', this.handleAuthStateChange);
    window.addEventListener('start-onboarding', this.handleStartOnboarding);
  }

  private initialEmail = '';

  private async checkRegistrationToken() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (token) {
      console.debug('>>> AppRoot: Registration token found in URL');
      const payload = (authService as any).parseJwt(token);
      if (payload && payload.email) {
          this.initialEmail = payload.email;
      }
      // Clear token from URL to keep it clean
      window.history.replaceState({}, document.title, window.location.pathname);
      
      try {
        await authService.completeRegistration(token);
        // Registration success will trigger auth-state-changed inside authService (via setToken)
      } catch (e) {
        console.error('Registration completion failed', e);
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener('auth-state-changed', this.handleAuthStateChange);
    window.removeEventListener('start-onboarding', this.handleStartOnboarding);
  }

  private handleAuthStateChange = (e: any) => {
    console.debug('>>> AppRoot: auth-state-changed received:', e.detail);
    this.render();
  };

  private handleStartOnboarding = () => {
    this.innerHTML = `<app-onboarding mode="new-org"></app-onboarding>`;
  };

  private isCheckingOnboarding = false;

  private async render() {
    const isAuthenticated = authService.isAuthenticated();
    
    if (!isAuthenticated) {
      if (this.initialEmail) {
        this.innerHTML = `<app-login email="${this.initialEmail}"></app-login>`;
      } else {
        this.innerHTML = `<app-login></app-login>`;
      }
      return;
    }

    if (this.isCheckingOnboarding) return;

    this.isCheckingOnboarding = true;
    
    // Show a minimal loading state or nothing while checking
    if (!this.innerHTML) {
      this.innerHTML = `<div class="drafting-grid" style="width:100vw;height:100vh;display:flex;align-items:center;justify-content:center;background:var(--surface);"><div class="spinner"></div></div>`;
    }

    try {
      const isFullyOnboarded = await onboardingService.isFullyOnboarded();
      
      const currentChild = this.firstElementChild;
      const targetTag = !isFullyOnboarded ? 'APP-ONBOARDING' : 'APP-SHELL';

      if (currentChild?.tagName !== targetTag) {
        this.innerHTML = !isFullyOnboarded ? `<app-onboarding></app-onboarding>` : `<app-shell></app-shell>`;
      }
    } catch (e) {
      console.error('Onboarding check failed', e);
      // Fallback to login if something is really wrong
      authService.logout();
    } finally {
      this.isCheckingOnboarding = false;
    }
  }
}

if (!customElements.get('app-root')) {
  customElements.define('app-root', AppRoot);
}
